import React, { useState } from 'react';
import { ChevronDown, Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const FAQ = () => {
  const { t } = useLanguage();
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section id="faq" className="py-24 bg-paper">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-12">
          <p className="text-mint text-sm font-bold uppercase tracking-[0.2em]">{t.faq.kicker}</p>
          <h2 className="mt-4 font-display font-extrabold text-4xl lg:text-5xl text-ink">
            {t.faq.title}
          </h2>
          <p className="mt-4 text-mute">{t.faq.intro}</p>
        </div>

        <div className="divide-y divide-line border-y border-line">
          {t.faq.items.map((faq, index) => {
            const open = openIndex === index;
            return (
              <div key={faq.q}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  className="w-full flex items-center justify-between gap-4 py-5 text-left group"
                  aria-expanded={open}
                >
                  <span className="font-display font-semibold text-ink text-base sm:text-lg group-hover:text-mint transition-colors">
                    {faq.q}
                  </span>
                  <ChevronDown
                    className={`w-5 h-5 text-mint shrink-0 transition-transform duration-300 ${
                      open ? 'rotate-180' : ''
                    }`}
                  />
                </button>
                {open && (
                  <p className="pb-5 text-mute leading-relaxed text-sm sm:text-base -mt-1">
                    {faq.a}
                  </p>
                )}
              </div>
            );
          })}
        </div>

        <div id="contact" className="mt-16 pt-10 border-t border-line">
          <h3 className="font-display font-bold text-xl text-ink">{t.faq.contactTitle}</h3>
          <p className="mt-2 text-mute text-sm">{t.faq.contactLead}</p>
          <div className="mt-6 flex flex-col sm:flex-row gap-3">
            <a
              href={`mailto:${t.faq.email}`}
              className="inline-flex items-center justify-center gap-2 border border-line hover:border-mint text-mint px-6 py-3 text-sm font-semibold transition-colors bg-surface"
            >
              <Mail className="w-4 h-4" />
              {t.faq.email}
            </a>
            <a
              href="/s"
              className="inline-flex items-center justify-center gap-2 bg-ember hover:bg-ember-deep text-white px-6 py-3 text-sm font-semibold transition-colors"
            >
              {t.headerCta}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
